// Is loaded by gulp and added to the layout.min.js

document.addEventListener('DOMContentLoaded', async () =>{

    $.notify.addStyle('template', {
        html: `
            <div>
                <h4 data-notify-text="title"></h4>
                <span data-notify-text="text"></span>
            </div>
    `
    });

    const notificationHubConnection = new signalR.HubConnectionBuilder()
        .withUrl("/notificationHub")
        .configureLogging(signalR.LogLevel.Warning)
        .build();

    const getType = type => {
        switch (type) {
            case 'danger': return 'error';
            default: return type;
        }
    };

    notificationHubConnection.on("SendNotificationAsync", function (subject, description, type) {
        $.notify({
            title: subject,
            text: description,
        }, {
            position: 'top center',
            autoHideDelay: 30000,
            className: getType(type),
            duration: 5000,
            style: 'template'
        });
    });

    const start = async () => {
        try {
            await notificationHubConnection.start();
        } catch (err) {
            console.log(err);
            setTimeout(start, 5000);
        }
    };

    notificationHubConnection.onclose(start);
    await start();
})